import { useState, useEffect } from "react";
import sanityClient from "../../client";

import "./index.css";

export const Footer = () => {
  const [data, setData] = useState([]);

  const fetchData = async () => {
    try {
      const query = `*[_type == 'sizzleReel'][0]`;
      const result = await sanityClient.fetch(query);
      setData(result);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleClick = () => {
    document.getElementById("video-reel-container").classList.add("show");
    document.getElementById("video-reel-container").classList.remove("hide");
  };

  console.log(data);

  return (
    <>
      <footer className="footer">
        <marquee width="100%" vspace="20" scrollamount="10" direction="left">
          <h1 onClick={() => handleClick()}>
            <span>{data.marqueeLabel ?? "SIZZLE REEL"}</span>
            <span>{data.marqueeLabel ?? "SIZZLE REEL"}</span>
            <span>{data.marqueeLabel ?? "SIZZLE REEL"}</span>
            <span>{data.marqueeLabel ?? "SIZZLE REEL"}</span>
            <span>{data.marqueeLabel ?? "SIZZLE REEL"}</span>
            <span>{data.marqueeLabel ?? "SIZZLE REEL"}</span>
          </h1>
        </marquee>
      </footer>
    </>
  );
};
